import React, { useState } from 'react';
import { BellIcon, SearchIcon, SettingsIcon, LogOutIcon, ChevronDownIcon } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
interface User {
  name: string;
  role: string;
  avatar: string;
}
interface TopNavBarProps {
  user: User;
}
export const TopNavBar = ({
  user
}: TopNavBarProps) => {
  const {
    isAuthenticated,
    is2FAVerified,
    logout
  } = useAuth();
  if (!isAuthenticated || !is2FAVerified) {
    return <></>;
  }
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const handleLogout = e => {
    e.preventDefault();
    logout();
  };
  return <header className="bg-white border-b border-gray-200 z-10" data-id="element-314">
      <div className="px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16" data-id="element-315">
        {/* Logo */}
        <div className="flex items-center" data-id="element-316">
          <div className="flex-shrink-0" data-id="element-317">
            <div className="flex items-center" data-id="element-318">
              <img className="w-28  object-contain" src="https://eu2.contabostorage.com/b9e17f24bf0f4437b03607562b167cff:image/default/onestop.jpg" data-id="element-319" />
            </div>
          </div>
        </div>
        {/* Search */}
        <div className="flex-1 max-w-xl ml-8 relative" data-id="element-320">
          <div className="relative w-full" data-id="element-321">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-322">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-323" />
            </div>
            <input type="text" placeholder="Search..." className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-324" />
          </div>
        </div>
        {/* Right side icons */}
        <div className="ml-4 flex items-center" data-id="element-325">
          {/* Notifications */}
          <div className="relative" data-id="element-326">
            <button className="p-1 rounded-full text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 relative" onClick={() => setNotificationsOpen(!notificationsOpen)} data-id="element-327">
              <BellIcon className="h-6 w-6" data-id="element-328" />
              <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-600 ring-2 ring-white" data-id="element-329"></span>
            </button>
            {notificationsOpen && <div className="origin-top-right absolute right-0 mt-2 w-80 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10" data-id="element-330">
                <div className="py-1" role="menu" aria-orientation="vertical" data-id="element-331">
                  <div className="px-4 py-2 border-b border-gray-200" data-id="element-332">
                    <p className="text-sm font-medium text-gray-700" data-id="element-333">
                      Notifications
                    </p>
                  </div>
                  <div className="max-h-72 overflow-y-auto" data-id="element-334">
                    <div className="px-4 py-2 border-b border-gray-100 hover:bg-gray-50" data-id="element-335">
                      <p className="text-sm font-medium text-gray-900" data-id="element-336">
                        New permit application submitted
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-337">10 minutes ago</p>
                    </div>
                    <div className="px-4 py-2 border-b border-gray-100 hover:bg-gray-50" data-id="element-338">
                      <p className="text-sm font-medium text-gray-900" data-id="element-339">
                        5 tax payments due today
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-340">1 hour ago</p>
                    </div>
                    <div className="px-4 py-2 border-b border-gray-100 hover:bg-gray-50" data-id="element-341">
                      <p className="text-sm font-medium text-gray-900" data-id="element-342">
                        System maintenance scheduled
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-343">Yesterday</p>
                    </div>
                  </div>
                  <div className="px-4 py-2 text-center" data-id="element-344">
                    <button className="text-sm text-blue-600 hover:text-blue-800 font-medium" data-id="element-345">
                      View all notifications
                    </button>
                  </div>
                </div>
              </div>}
          </div>
          {/* User menu */}
          <div className="ml-4 relative" data-id="element-346">
            <button className="flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500" onClick={() => setUserMenuOpen(!userMenuOpen)} data-id="element-347">
              <img className="h-8 w-8 rounded-full object-cover" src={user.avatar} alt={user.name} data-id="element-348" />
              <div className="hidden md:flex md:items-center ml-2" data-id="element-349">
                <span className="text-sm font-medium text-gray-700 mr-1" data-id="element-350">
                  {user.name}
                </span>
                <ChevronDownIcon className="h-4 w-4 text-gray-500" data-id="element-351" />
              </div>
            </button>
            {userMenuOpen && <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10" data-id="element-352">
                <div className="py-1" role="menu" aria-orientation="vertical" data-id="element-353">
                  <div className="px-4 py-2 border-b border-gray-200" data-id="element-354">
                    <p className="text-sm font-medium text-gray-900" data-id="element-355">
                      {user.name}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-356">{user.role}</p>
                  </div>
                  <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" data-id="element-357">
                    <SettingsIcon className="mr-3 h-4 w-4 text-gray-500" data-id="element-358" />
                    Settings
                  </a>
                  <a href="javascript:void(0)" onClick={handleLogout} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" data-id="element-359">
                    <LogOutIcon className="mr-3 h-4 w-4 text-gray-500" data-id="element-360" />
                    Sign out
                  </a>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </header>;
};